import * as yup from "yup";
import { jfetch, snakeCaseKeys } from "../utils";

export const CREDIT_APPLICATION_WIDGET_URL =
  "https://chartec.na1.echosign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhDWA94aTaxL1Dd878VUqWQ9zfky3MltMbmQaB0wpx9DxHxpf16FTZ79M70YLWNcTm8*&hosted=false";
export const HAAS_ADDENDUM_WIDGET_URL =
  "https://chartec.na1.echosign.com/public/esignWidget?wid=CBFCIBAA3AAABLblqZhDrDxDjKSyyB_uYaGWbSHS1vXq7Nhs8nhtRv_uTEXE4Ms0covrLDA-u9CSG5ahTJ90*&hosted=false";

export const companyInfoGrabValidationSchema = yup.object().shape({
  locationAndNearbyCities: yup.string(),
  lobTools: yup.string(),
  books: yup.string(),
  lengthOfBusiness: yup.string(),
  marketPopulation: yup.string(),
  clientsOrEndpoints: yup.string(),
  avgClientSize: yup.string(),
  remoteLocations: yup.string(),
  pctMgdService: yup.string(),
  techCerts: yup.string(),
  growthGoalsAndEndYrStrat: yup.string(),
  currentBusinessIssues: yup.string(),
  keepDoing: yup.string(),
  salesStruggles: yup.string(),
  marketingStruggles: yup.string(),
  operationsStruggles: yup.string(),
  annualRevenue: yup
    .string()
    .oneOf(["<1m", "1m-4.9m", "5m-9.9m", "10m-14.9m", "15m-19.9m", ">=20m"]),
  orgSize: yup.string().oneOf(["1-5", "6-10", "11-15", "16-25", "26+"]),
  missionStatement: yup.string(),
});

export function saveOnboardData(
  org: IOrganizationRecord,
  onboardData: Partial<IOnboardDataAttributes>
) {
  return jfetch.patch(`${org.links.url}/onboard_data`, {
    onboard_data: snakeCaseKeys(onboardData),
  });
}

export function getOnboardData(org: IOrganization | IOrganizationRecord) {
  return jfetch.get<IJsonApiResponse<IOnboardDataRecord>>(
    `${org.links.url}/onboard_data`
  );
}



// WEBPACK FOOTER //
// ./app/javascript/libs/onboard.ts